module.exports = __webpack_public_path__ + "static/the-grapes-of-wrath-94df61f2814ab356dd354d3fe97ac399.jpg";